import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import PropTypes from "prop-types";
import { TabPanel } from "./TabPanel";
import ViewInvoice2 from "./ViewInvoic2";
import QualityParamsModal from "./QualityParamsModal";
import ViewInvoice from "./ViewInvoice";
import { Button, Spinner } from "react-bootstrap";
import { usePostReportMutation } from "./ProcurementApiSlice";
export const DetailDescriptionSeller = ({
  data,
  invoice,
  procCode,
  type,
  showBuyerName,
  user_id,
}) => {
  const [postReport] = usePostReportMutation();
  const [loadingone, setShowLoadingOne] = useState(false);
  const [value, setValue] = useState(0);
  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  const handleDownloadSummary = () => {
    let payload = {
      ProcCode: procCode,
      entity_type: type,
      user_id: user_id,
    };
    setShowLoadingOne(true);
    postReport(payload)
      .unwrap()
      .then((data) => {
        const fileURL = data?.data?.url || "";
        const alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "summary.pdf";
        alink.target = "_blank";
        alink.click();
        setShowLoadingOne(false);
      })
      .catch((error) => {
        setShowLoadingOne(false);
      });
  };

  return (
    <div>
      <div className="d-flex flex-lg-row flex-column justify-content-between">
        <Tabs value={value} onChange={handleChangeTabs}>
          <Tab label="Details" />
          <Tab className="mx-2" label="Documents" />
        </Tabs>
        <div className="d-flex">
          {data?.status === "Completed" && (
            <Button
              className="buttonOrangeDefaultColor2 mt-3  mb-2"
              size="sm"
              onClick={() => handleDownloadSummary()}
            >
              Summary Report <i class="mdi mdi-download"></i>
              {loadingone ? <Spinner size="sm" /> : ""}
            </Button>
          )}
          {data?.all_media?.map((item) => {
            return (
              <div>
                {item.entity_type === "Buyer" &&
                item.file_source === "Uploaded" &&
                item.pattern === "Purchase Order" ? (
                  <Button
                    className="buttonOrangeDefaultColor2 mt-3  mb-2"
                    size="sm"
                  >
                    <a
                      href={item.file}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Purchase Order
                    </a>
                  </Button>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      </div>

      <TabPanel value={value} index={0} className="CrmModuleNoPadding">
        <div>
          {/* Image */}
          <div style={{ textAlign: "center" }}>
            <img
              src={data.image_url}
              alt={data.crop_name}
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </div>

          <div>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", textAlign: "center" }}
            >
              {data.crop_name}
            </Typography>
            <Typography
              variant="body1"
              sx={{ textAlign: "center", marginBottom: "10px" }}
            >
              ₹{" "}
              {data?.final_price === 0.0 || data?.final_price === 0
                ? data?.price
                : data?.final_price}{" "}
              per {data.unit_of_measure} | Quantity:{" "}
              {data?.final_quantity === 0.0 || data?.final_quantity === 0
                ? data?.quantity
                : data?.final_quantity}{" "}
              {data.unit_of_measure}
            </Typography>
            {data.final_price !== 0 && data.final_quantity !== 0 && (
              <Typography
                variant="body2"
                sx={{
                  textAlign: "center",
                  color: "gray",
                  marginBottom: "10px",
                  fontStyle: "italic",
                }}
              >
                The Quoted price and Quoted quantity for this trade are Price:
                <span className="text-warning"> ₹{data.price} </span>, Quantity:{" "}
                <span className="text-warning">
                  {data.quantity} {data.unit_of_measure}{" "}
                </span>
                . However, the final deal is negotiated at
                <span className="text-warning"> ₹{data.final_price} </span>and
                quantity:{" "}
                <span className="text-warning">
                  {data.final_quantity} {data.unit_of_measure}
                </span>
                .
              </Typography>
            )}

            <Divider sx={{ margin: "10px 0" }} />
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Bag Type:
                </Typography>
                <Typography variant="body2">{data.bag_type}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Bag Weight:
                </Typography>
                <Typography variant="body2">
                  {data.bag_weight} {data.bag_weight_unit}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Weight Type:
                </Typography>
                <Typography variant="body2">{data.weight_type}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Weight Tolerance:
                </Typography>
                <Typography variant="body2">{data.weigth_tolerance}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Delivery Timeline:
                </Typography>
                <Typography variant="body2">
                  {data?.delivery_and_payment_detail?.delivery_timeline
                    ? data?.delivery_and_payment_detail?.delivery_timeline
                    : "-"}{" "}
                  (Days)
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Payment Type:
                </Typography>
                <Typography variant="body2">
                  {data?.delivery_and_payment_detail?.payment_type
                    ? data?.delivery_and_payment_detail?.payment_type
                    : "-"}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Payment Timeline:
                </Typography>
                <Typography variant="body2">
                  {data?.delivery_and_payment_detail?.payment_timeline
                    ? data?.delivery_and_payment_detail?.payment_timeline
                    : "-"}{" "}
                  (Days)
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Approval Date:
                </Typography>
                <Typography variant="body2">{data?.approval_date}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Expiry (Negotiation):
                </Typography>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  <span style={{ color: "red" }}>
                    {data?.negotiation_detail?.is_expired
                      ? "Expired"
                      : data?.negotiation_detail?.expired_in}
                  </span>
                </Typography>
              </Grid>
              {showBuyerName ? (
                <>
                  <Grid item xs={4}>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      Buyer Name:
                    </Typography>
                    <Typography variant="body2">
                      {data?.created_name}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      Delivery Location:
                    </Typography>
                    <Typography variant="body2">
                      {data?.StateName} , {data.DistrictName} , {data.BlockName}{" "}
                      , {data.pincode}
                    </Typography>
                  </Grid>
                </>
              ) : type === "Buyer" ? (
                <>
                  <Grid item xs={4}>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      Seller Name:
                    </Typography>
                    <Typography variant="body2">{data?.seller_name}</Typography>
                  </Grid>
                  {/* <Grid item xs={4}>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      Expiry (Negotiation):
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      <span style={{ color: "red" }}>
                        {data?.negotiation_detail?.is_expired
                          ? "Expired"
                          : data?.negotiation_detail?.expired_in}
                      </span>
                    </Typography>
                  </Grid> */}
                </>
              ) : (
                ""
              )}
            </Grid>
          </div>
          <Divider sx={{ margin: "10px 0" }} />
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            Quality Parameters:
          </Typography>

          <QualityParamsModal qualityParams={data?.quality_parameters} />
        </div>
      </TabPanel>
      <TabPanel value={value} index={1} className="CrmModuleNoPadding">
        {type === "Seller" ? (
          <ViewInvoice2 procCode={procCode} invoice={invoice} FullList={data} />
        ) : (
          <ViewInvoice procId={procCode} invoice="invoice_2" FullList={data} />
        )}
      </TabPanel>
    </div>
  );
};
